<template>
  <ImagePreview
    class="carousel-image-preview"
    :images="images"
    :start-position="current"
    @change="onChange"
    @close="onClose"
  >
    <template #toolbar>
      <div class="carousel-image-preview-toolbar">
        <div
          class="carousel-image-preview-switch"
          @click="onSwitch"
        >
          <div
            class="carousel-image-preview-switch__node"
            :class="{
              'carousel-image-preview-switch__node--active': active === 'styles'
            }"
          />
          <div class="carousel-image-preview-switch__item carousel-image-preview-switch__left">
            Images
          </div>
          <div
            v-if="stylesLength"
            class="carousel-image-preview-switch__item carousel-image-preview-switch__right"
          >
            Styles
          </div>
        </div>
        <div class="carousel-image-preview-progress">
          <div
            class="carousel-image-preview-progress__line"
            :style="{
              width: `${(index + 1) / length * 100}%`
            }"
          />
        </div>
        <div class="carousel-image-preview-step">
          {{ index + 1 }} / {{ length }}
        </div>
      </div>
      <Button
        class="carousel-image-preview-button"
        :block="false"
        @click="onFindSimilar"
      >
        <Icon
          class="carousel-image-preview-button__icon"
          name="icon-image-search-similar"
        />
        Find Similar
      </Button>
    </template>
  </ImagePreview>
</template>

<script setup>
import { Button } from '@/components/Button'
import { Icon } from '@/components/Icon'
import { ImagePreview } from '@/components/ImagePreview'

const props = defineProps({
  images: {
    type: Array,
    required: true
  },
  productsLength: {
    type: Number,
    required: true
  },
  stylesLength: {
    type: Number,
    required: true
  },
  index: {
    type: Number,
    required: true
  }
})
const emit = defineEmits(['close', 'findSimilar'])

const current = ref(props.index)

watch(() => props.index, (index) => {
  current.value = index
})

const active = computed(() => {
  return current.value < props.productsLength ? 'products' : 'styles'
})
/**
 * 展示的索引和长度，需要区分当前处于 images 还是 styles
 */
const index = computed(() => {
  return active.value === 'products' ? current.value : current.value - props.productsLength
})
const length = computed(() => {
  return active.value === 'products' ? props.productsLength : props.stylesLength
})

const onChange = (index) => {
  current.value = index
}

const onClose = () => {
  emit('close', current.value)
}

const onSwitch = () => {
  if (current.value < props.productsLength) {
    current.value = props.productsLength
  } else {
    current.value = 0
  }
}

const onFindSimilar = () => {
  emit('findSimilar', props.images[current.value])
}
</script>

<style lang="less">
.carousel-image-preview {
  &-toolbar {
    position: relative;
    padding: 12px 16px;
    width: 100%;
  }

  &-switch {
    position: absolute;
    top: -32px;
    left: 50%;
    transform: translateX(-50%);
    padding: 2px;
    background: rgba(20, 20, 20, 0.64);
    border-radius: 12px;
    z-index: 9;
    padding: 2px;
    box-sizing: border-box;
    display: flex;

    &__item {
      width: 53.5px;
      color: #FFFFFF;
      font-family: mon-400;
      font-size: 11px;
      line-height: 20px;
      text-align: center;
    }

    &__node {
      z-index: -1;
      position: absolute;
      left: 2px;
      top: 2px;
      bottom: 2px;
      width: 53.5px;
      background-color: #232323;
      border-radius: 10px;
      transition: all 0.3s ease;

      &--active {
        left: 50%;
      }
    }
  }

  &-progress {
    height: 4px;
    width: 100%;
    border-radius: 2px;
    background-color: #494D51;

    &__line {
      height: 100%;
      width: 0%;
      border-radius: inherit;
      background-color: #969AA3;
      transition: all .3s ease-in-out;
    }
  }

  &-step {
    margin-top: 24px;
    color: #B2B7C2;
    font-family: mon-500;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }

  &-button {
    position: fixed;
    right: 16px;
    bottom: 34px;
    left: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    background: #F57231;

    &__icon {
      font-size: 24px;
    }
  }
}
</style>
